import React, { useEffect, useState } from 'react';
import Config from '../../config/Config';
import $ from 'jquery';
import Loader from '../../utils/Loader';
import { conditionallyClearStorage } from '../../utils/commonFunctions';
import Auth from '../../utils/Auth';
import { connect } from 'react-redux';
import { setInitialMyStepDetails } from '../../redux/mystep/mystep.actions';

import { otplogin } from '../../redux/userAuthentication/userAuth.actions';
const PaymentSuccess = ({
	setInitialMyStepDetails,
	childToken,
	activeChildId,
	supportEmail,
	supportPhone,
	otplogin,
}) => {
	const [text, setContinueText] = useState('');
	const [redirectURL, setRedirectURL] = useState('');
	const isNewUser =
		localStorage.getItem('new_user') &&
		localStorage.getItem('new_user').toLowerCase() === 'true';
	const isChildCourse = localStorage.getItem('isChildCourse') === 'true';
	const orderId = localStorage.getItem('orderId');
	const productName = localStorage.getItem('gtm_prod_name');
	const clearStorage = () => {
		if (localStorage.getItem('sso') === '0') {
			conditionallyClearStorage([
				'currentProductId',
				'sso',
				'referer',
				'gtm_prod_final',
				'active_course_id',
				'login_user_id',
				'login_id',
				'orderId',
				'return_path',
				'gtm_prod_name',
			]);
		}
	};

	useEffect(() => {
		$('.download-app').hide();
		$('.body-container').css('background', '#e5f3fa');

		localStorage.setItem('postBuySignIn', true);

		Loader.hide();
		document.getElementById('chat-circle').style.display = 'none';
		return () => {
			clearStorage();
			document.getElementById('chat-circle').style.display = 'block';
		};
	}, []);

	useEffect(() => {
		setInitialMyStepDetails();
	}, [setInitialMyStepDetails]);

	useEffect(() => {
		if (localStorage.getItem('sso') === '0') {
			localStorage.setItem('return_path', 'mycourse');
			Auth.isAuthenticated = null;
			setRedirectURL(
				isChildCourse ? '/parent/verifyotp' : isNewUser ? '/verifyuser' : '/',
			);
			setContinueText(
				isNewUser
					? 'Click Continue and verify your account to start course.'
					: 'Click Continue and login to start course.',
			);
		} else {
			setContinueText('Click continue to start the course.');
			setRedirectURL(
				!!childToken ? `/child/dashboard/${activeChildId}` : '/mycourse',
			);
		}
		if (!!isChildCourse) {
			otplogin(localStorage.getItem('login_id'));
		}
	}, [isNewUser, otplogin, activeChildId, isChildCourse, childToken]);
	return (
		<div>
			<div className="container nopadding-mobile">
				<div className="row">
					<div
						className="col-lg-12 col-lg-offset-2 text-center"
						style={{ 'margin-top': '50px' }}
					>
						<img
							className="paymentStatusIcon"
							alt="success"
							src={`${Config.ASSETSPATH}img/payment_success.gif`}
						/>
						<p className="payment-success-text">
							Congratulations! You have successfully purchased the product.
						</p>
						{!!orderId &&
						orderId !== 'null' &&
						!!productName &&
						productName !== 'null' ? (
							<table className="table table-bordered">
								<tbody>
									<tr>
										<td>Transaction ID</td>
										<td className="number_strong">{orderId}</td>
									</tr>

									<tr>
										<td>Course Name</td>
										<td className="number_strong">{productName}</td>
									</tr>
								</tbody>
							</table>
						) : null}
						<p className="payment-continue-text">{text}</p>
						<a href={redirectURL} onClick={clearStorage}>
							<button aria-label="continue" className="btn btn-success">
								Continue
							</button>
						</a>
						<div>
							<img
								src={Config.ASSETSPATH + 'img/payment_logo.png'}
								className="mt-5"
								alt="Logo"
							/>
						</div>
						<div className="stayconnect">
							<h5>
								If you have any questions or problems, don't hesitate to email us at{' '}
								<a href={`mailto:${supportEmail || 'info@steptest.in'}`} target="_top">
									{supportEmail || 'info@steptest.in'}
								</a>{' '}
								or whatsapp us at
							</h5>
							{!!supportPhone && supportPhone.includes(',') ? (
								supportPhone.split(',').map((phone, i) => (
									<>
										<a
											href={`https://web.whatsapp.com/send?phone=${phone}&text=Hello%2C%20I%27m%20Interested%20in%20buying%20this%20course`}
											rel="noopener noreferrer"
											target="_blank"
										>
											{phone}
										</a>
										{i < supportPhone.split(',').length - 2
											? ','
											: i < supportPhone.split(',').length - 1
											? ' or'
											: ' '}
									</>
								))
							) : (
								<a
									href={`https://web.whatsapp.com/send?phone=+91${
										supportPhone || 9789883344
									}&amp;text=I%20was%20on%20the%20STEP%20website%2C%20and%20I%20wish%20to%20know%20more`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										alt="whatsapp"
										src={`${Config.ASSETSPATH}img/whatsapp-icon.png`}
									/>{' '}
									+91 {supportPhone || 9789883344}
								</a>
							)}
							with your order details.
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		setInitialMyStepDetails: () => dispatch(setInitialMyStepDetails()),
		otplogin: (val) => dispatch(otplogin(val)),
	};
};

const mapStateToProps = (state) => {
	const { childToken, activeChildId } = state.rootReducer.parentDetails;
	const {
		supportEmail = 'info@steptest.in',
		supportPhone = '9789883344',
	} = state.rootReducer.loginDetails;
	return {
		childToken,
		activeChildId,
		supportEmail,
		supportPhone,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);
